export const splitTextToSpans = (text: string) => {
  return (
    <>
      {text.split('').map((letter, idx) => (letter === ' ' ? letter : <span key={`fancyLetter${idx}`}>{letter}</span>))}
    </>
  );
};
